export const getPrescriptionValue = (retainerRequestFormValue, supportedRetainerTypes = []) => {
    // console.log('retainerRequestFormValue', retainerRequestFormValue)
    // console.log(JSON.stringify(retainerRequestFormValue , null , 4))
    // console.log('supportedRetainerTypes', supportedRetainerTypes)
    if (!retainerRequestFormValue || !supportedRetainerTypes || !supportedRetainerTypes.length)
        return {
            upperPart: null,
            lowerPart: null,
            specialInsrtuction: '',
        };
    let upperRetainerType = null;
    let lowerRetainerType = null;
    upperRetainerType = supportedRetainerTypes.find(
        (r) => r.retainer_type_id === retainerRequestFormValue.upper_retainer_type_id
    );
    lowerRetainerType = supportedRetainerTypes.find(
        (r) => r.retainer_type_id === retainerRequestFormValue.lower_retainer_type_id
    );
    const upperRetainerTypeId = upperRetainerType ? upperRetainerType.retainer_type_id : 0;
    const lowerRetainerTypeId = lowerRetainerType ? lowerRetainerType.retainer_type_id : 0;
    // const
    return {
        upperPart: {
            upperBiteRamp: retainerRequestFormValue.upper_bite_ramp || [], // array of numbers
            upperBleachingRetainersSelect: retainerRequestFormValue.upper_bleaching_retainers_select || '',
            upperLowTrimlineAreaSelect_3: retainerRequestFormValue.upper_LowTrimlineAreaSelect_3 || '',
            upperLowTrimlineAreaSelect_1: retainerRequestFormValue.upper_LowTrimlineAreaSelect_1 || '',
            upperJigPlacementSelect: retainerRequestFormValue.upper_jig_placement_select || '',
            // upperClearRetainerDesignLowerOption: retainerRequestFormValue.upper_clear_retainer_design_lower_option,
            // upperClearRetainerDesignLowerOptionForSecondSet: retainerRequestFormValue.upper_clear_retainer_design_lower_option_for_second_set,
            upperClearRetainerDesignUpperOption: retainerRequestFormValue.upper_clear_retainer_design_upper_option,
            upperClearRetainerDesignUpperOptionForSecondSet:
                retainerRequestFormValue.upper_clear_retainer_design_upper_option_for_second_set,
            // upperFixedPalatalWireSelect: retainerRequestFormValue.upper_fixed_palatal_wire_select || '',
            upperWireSelect: retainerRequestFormValue.upper_wire_select || '',
            upperFixedWire: retainerRequestFormValue.upper_fixed_wire || 0, // tinyint from database as a boolean
            // upperPontics: retainerRequestFormValue.upper_pontics || [], // array of numbers
            upperRetainerTypeId: upperRetainerTypeId,

            upperPontic: retainerRequestFormValue.upper_pontic || '',
            upperPonticColor: retainerRequestFormValue.upper_pontic_color || '',
        },
        lowerPart: {
            lowerBiteRamp: retainerRequestFormValue.lower_bite_ramp || [], // array of numbers
            lowerBleachingRetainersSelect: retainerRequestFormValue.lower_bleaching_retainers_select || '',
            lowerLowTrimlineAreaSelect_3: retainerRequestFormValue.lower_LowTrimlineAreaSelect_3 || '',
            lowerLowTrimlineAreaSelect_1: retainerRequestFormValue.lower_LowTrimlineAreaSelect_1 || '',
            lowerJigPlacementSelect: retainerRequestFormValue.lower_jig_placement_select || '',
            lowerClearRetainerDesignLowerOption: retainerRequestFormValue.lower_clear_retainer_design_lower_option,
            lowerClearRetainerDesignLowerOptionForSecondSet:
                retainerRequestFormValue.lower_clear_retainer_design_lower_option_for_second_set,
            // lowerClearRetainerDesignUpperOption: retainerRequestFormValue.lower_clear_retainer_design_upper_option,
            // lowerClearRetainerDesignUpperOptionForSecondSet: retainerRequestFormValue.lower_clear_retainer_design_upper_option_for_second_set,
            // lowerFixedPalatalWireSelect: retainerRequestFormValue.lower_fixed_palatal_wire_select || '',
            lowerWireSelect: retainerRequestFormValue.lower_wire_select || '',
            lowerFixedWire: retainerRequestFormValue.lower_fixed_wire || 0, // tinyint from database as a boolean
            lowerPontics: retainerRequestFormValue.lower_pontics || [], // array of numbers       ,
            lowerRetainerTypeId: lowerRetainerTypeId,

            lowerPontic: retainerRequestFormValue.lower_pontic || '',
            lowerPonticColor: retainerRequestFormValue.lower_pontic_color || '',
        },
        specialInsrtuction: retainerRequestFormValue?.special_instruction || '',
    };
};
